import {Component, HostListener, Injector, OnInit} from '@angular/core';
import {Meta, Title} from '@angular/platform-browser';
import {BaseComponents} from '../../shared/base-components';
import {TYPE_META} from '../../core/constants/meta_title.constant';

@Component({
    selector: 'app-como-funciona',
    templateUrl: './como-funciona.component.html',
    styleUrls: ['./como-funciona.component.sass']
})
export class ComoFuncionaComponent extends BaseComponents implements OnInit {
    constructor(protected injector: Injector,
                protected titleService: Title,
                protected meta: Meta) {
        super(injector);
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.handleMobile();
    }

    ngOnInit() {
        super.ngOnInit();
        this.setMetaTitle(TYPE_META.COMO_FUNCIONA);
    }
}
